(function () {
  'use strict';

  var SECTION_NAME = 'quick-cart';
  var SECTION_URL = '/cart?sections=' + SECTION_NAME;

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-variant-picker]');
    if (select) handleVariantChange(select);
  });

  function handleVariantChange(select) {
    var item = select.closest('[data-input-item]');
    if (!item) return;

    var lineKey = select.dataset.lineKey;
    var currentVariantId = select.dataset.currentVariantId;
    var newVariantId = select.value;
    var quantity = parseInt(select.dataset.quantity, 10) || 1;

    if (!lineKey || !newVariantId || newVariantId === currentVariantId) return;

    var errorEl = item.querySelector('.quick-cart__item-error');
    var properties = readProperties(item);
    var sellingPlanId = item.dataset.sellingPlanId || null;

    setLoading(select, item, true);
    hideError(errorEl);

    addToCart(newVariantId, quantity, properties, sellingPlanId)
      .then(function () { return changeLine(lineKey, 0); })
      .then(rerenderSection)
      .then(function (html) {
        swapSection(html);
        document.dispatchEvent(new CustomEvent('mutimer:cart_variant_change', {
          detail: {
            product_id: item.dataset.productId || null,
            from_variant_id: currentVariantId,
            to_variant_id: newVariantId,
            quantity: quantity,
            view_context: 'quick_cart'
          }
        }));
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { source: 'quick-cart-variant' }
        }));
      })
      .catch(function (err) {
        showError(errorEl, err && err.description);
        select.value = currentVariantId;
        setLoading(select, item, false);
      });
  }

  function readProperties(item) {
    var script = item.querySelector('script[data-item-properties]');
    if (!script) return {};
    try { return JSON.parse(script.textContent) || {}; }
    catch (e) { return {}; }
  }

  function setLoading(select, item, loading) {
    select.disabled = loading;
    item.dataset.loading = loading ? 'true' : 'false';
  }

  function showError(el, message) {
    if (!el) return;
    if (message) el.textContent = message;
    el.classList.remove('hidden');
  }

  function hideError(el) {
    if (el) el.classList.add('hidden');
  }

  function addToCart(variantId, quantity, properties, sellingPlanId) {
    var body = { id: parseInt(variantId, 10), quantity: quantity };
    if (properties && Object.keys(properties).length > 0) body.properties = properties;
    if (sellingPlanId) body.selling_plan = parseInt(sellingPlanId, 10);
    return postJson('/cart/add.js', body);
  }

  function changeLine(lineKey, quantity) {
    return postJson('/cart/change.js', { id: lineKey, quantity: quantity });
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && data.description) || 'Cart update failed');
          err.description = data && data.description;
          throw err;
        }
        return data;
      });
    });
  }

  function rerenderSection() {
    return fetch(SECTION_URL, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Section render failed');
        return res.json();
      })
      .then(function (data) { return data[SECTION_NAME]; });
  }

    function swapSection(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.quick-cart__container');
    var current = document.querySelector('.quick-cart__container');
    if (!fresh || !current) return;

    // Preserve the live cross-sells element so its Swiper instance survives.
    // Safe because variant swaps don't change which products are in the cart.
    var liveCrossSells = current.querySelector('[data-cross-sells]');
    var freshCrossSells = fresh.querySelector('[data-cross-sells]');
    if (liveCrossSells && freshCrossSells) {
        freshCrossSells.replaceWith(liveCrossSells);
    }

    current.replaceChildren.apply(current, [].slice.call(fresh.childNodes));
    }
})();